import { Link } from 'react-router-dom'
import styled from 'styled-components'

const SimpleLink = styled(Link)<{ textDecoration?: string; width?: string }>`
  width: ${({ width = 'fit-content' }) => width};
  color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  text-decoration: ${({ textDecoration }) => textDecoration || 'none'};

  &:hover,
  &:link {
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    text-decoration: ${({ textDecoration }) => textDecoration || 'none'};
  }
`

export default SimpleLink
